export function deserializeOrganizer(
	html: string,
	response: string,
	aspUrl: string,
	readonly: boolean
) {
	// Set organizer image URLs while removing virtual
	// directory prefixes.
	const _html = html.replaceAll(
		/(<img src=["'])\/[^\/]*\/(images\/[^"']*["'])/gi,
		`$1${aspUrl}/$2`
	);

	const _dom = document.createElement("div");
	_dom.innerHTML = _html;

	if (response) {
		var formData = JSON.parse(response);
		for (var prop in formData) {
			var input = _dom.querySelector(`input[name="${prop}"]`) as HTMLInputElement;
			var textarea = _dom.querySelector(`textarea[name="${prop}"]`) as HTMLTextAreaElement;

			if (input && input.type == "checkbox") {
				if (formData[prop].value) {
					input.checked = formData[prop].value;
				} else {
					input.checked = formData[prop];
				}
				input.readOnly = readonly;
			} else if (input && !input.classList.contains(".do-not-serialize")) {
				if (formData[prop].value !== undefined) {
					input.value = formData[prop].value.toString();
				} else {
					input.value = formData[prop];
				}
				input.readOnly = readonly;
			} else if (textarea && !textarea.classList.contains(".do-not-serialize")) {
				if (formData[prop].value !== undefined) {
					textarea.textContent = formData[prop].value.toString();
				} else {
					textarea.textContent = formData[prop];
				}
				textarea.readOnly = readonly;
			}
		}
	}

	return _dom;
}

export function serializeOrganizer() {
	var inputs = document.querySelectorAll(".organizer input");
	var textareas = document.querySelectorAll(".organizer textarea");
	var serial: any = {};
	textareas.forEach((elem) => {
		const textarea = elem as HTMLTextAreaElement;
		if (!textarea.classList.contains(".do-not-serialize")) {
			serial[textarea.name] = {
				value: textarea.value,
			};
		}
	});
	inputs.forEach((elem) => {
		const input = elem as HTMLInputElement;
		if (!input.classList.contains(".do-not-serialize")) {
			if (input.type == "checkbox") {
				serial[input.name] = {
					value: input.checked,
				};
			} else {
				serial[input.name] = {
					value: input.value,
				};
			}
		}
	});
	return serial;
}
